import type { TranslationGetter } from '../../../types';
import type { TranslationService as BaseTranslationService } from '../../_shared/Form/services/TranslationService';

export class TranslationService {
  private copies: ReturnType<TranslationService['createSingleBillInfoFormWidgetCopy']>;

  constructor(private t: TranslationGetter, private baseTranslation: BaseTranslationService) {
    this.copies = this.createSingleBillInfoFormWidgetCopy();
  }

  public api() {
    return {};
  }

  public handlers() {
    return {};
  }

  public data() {
    return {
      getSingleBillInfoFormWidgetCopy: () => this.copies,
    };
  }

  private createSingleBillInfoFormWidgetCopy() {
    const { t, baseTranslation } = this;

    return {
      ...baseTranslation.getCopies(),
      phone: t('application-layer.single-bill-info.phone'),
      email: t('application-layer.single-bill-info.email'),
      addressLine2: t('application-layer.single-bill-info.address-line2'),
      billingEmail: t('application-layer.single-bill-info.email'),
      billingDayOfMonth: t('application-layer.single-bill-info.billing-day'),
      currency: t('application-layer.single-bill-info.currency'),
      partnerContact: t('application-layer.single-bill-info.partner-contact'),
      partnerContactName: t('application-layer.single-bill-info.partner-contact-name'),
      partnerContactEmail: t('application-layer.single-bill-info.partner-contact-email'),
      additionalInfoHeader: t('application-layer.single-bill-info.additional-info-header'),
      additionalInfoText: t('application-layer.single-bill-info.additional-info-text'),
      edit: t('application-layer.single-bill-info.edit'),
    };
  }
}
